<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd">新增</el-button>
        <el-button type="primary" :disabled="Status === 2" style="margin-left: 4px" @click="save">保存</el-button>
        <el-button type="primary" :disabled="isSave" @click.native="orderReview">{{ ReviewName }}</el-button>
        <div class="text-box">制单人：{{ MakeEmpName }}</div>
        <div class="text-box">审核人：{{ ReviewEmpName }}</div>
      </div>
      <el-table border key="table1" class="table_bottom table-line tb-c-head" :data="tableData" stripe style="margin-top: 18px" ref="table1">
        <el-table-column label="模号" prop="MouldNo" align="center" min-width="180"></el-table-column>
        <el-table-column label="模具名称" align="center" min-width="120" prop="MouldName">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.MouldName }}</span>
            <account-select
              v-else
              v-model="row.MouldName"
              :source="DAccount"
              @select="onSelect($event, row)"
              @inputText="inputText($event, row)"
              :listTotal="listTotal"
              @click.native="resetFun"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              @currentPage="currentPage($event, row)"
              :pageType="true"
              :Head="Head"
            />
          </template>
        </el-table-column>
        <el-table-column label="每模毛重" prop="PerGrossWeight" align="center" min-width="100"></el-table-column>
        <el-table-column label="每模净重" prop="PerNetWeight" align="center" min-width="100"></el-table-column>
        <el-table-column label="模数" prop align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-input v-model="row.Quantity" placeholder="请输入数量" v-if="Status === 0" />
            <span v-else>{{ row.Quantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="viewImg(row)"
            >查看</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="备注" prop align="center" min-width="100"></el-table-column>
        <el-table-column label="bom版本" prop="BomNo" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.BomNo" placeholder="请输入版本号" v-if="Status === 0" />
            <span v-else>{{ row.BomNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成品率%" prop="Yieldrate" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.Yieldrate" placeholder="请输入成品率" v-if="Status === 0" />
            <span v-else>{{ row.Yieldrate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="生产类型"
          prop="ProductionType"
          align="center"
          min-width="100"
        >
        <template slot-scope="{ row }">
            <el-select v-model="row.ProductionType"  v-if="Status === 0">
              <el-option key="ProductionType1" label="自产" :value="0"></el-option>
              <el-option key="ProductionType2" label="委外" :value="1"></el-option>
              <el-option key="ProductionType3" label="自产&委外" :value="2"></el-option>
            </el-select>
            <span v-else>{{row.ProductionType === 0 ? '自产' : row.ProductionType === 1 ? '委外' : '自产&委外'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="外协供应商编码"
          prop="ProductionDpNo"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          label="外协供应商名称"
          prop="ProductionDpId"
          align="center"
          min-width="120"
        >
        <template slot-scope="{ row }">
            <el-select v-model="row.ProductionDpId "  v-if="Status === 0"  @change="changeProductionDp($event, row)"  :disabled="Status === 1 || row.ProductionType !== 1">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
            </el-select>
            <span v-else>{{row.PropertyName}}</span>
          </template>
        </el-table-column>-->
        <el-table-column label="默认BOM" prop="IsDefault" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.IsDefault" v-if="Status === 0">
              <el-option key="IsDefault1" label="是" :value="true"></el-option>
              <el-option key="IsDefault2" label="否" :value="false"></el-option>
            </el-select>
            <span v-else>{{ row.IsDefault ? '是' : '否' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-tabs tab-position="top" class="tabs" type="card" @tab-click="tabClick">
        <el-tab-pane>
          <div slot="label">模具子件</div>
          <el-table
            border
            key="table2"
            class="table_bottom table-line tb-c-head"
            :data="DetailDtos"
            stripe
            style="margin-top: 18px"
            ref="table2"
            @row-click="addColumn"
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="子件编码" prop="ProductNo" align="center" min-width="180"></el-table-column>
            <el-table-column label="子件名称" align="center" min-width="120" prop="ProductName">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
                <account-select
                  v-else
                  v-model="row.ProductName"
                  :source="child_DAccount"
                  @select="onSelect($event, row, 1)"
                  @inputText="inputChildText($event, row)"
                  @click.native="resetChildFun"
                  @currentPage="currentChildPage($event, row)"
                  :pageType="true"
                  :pageSize="child_pageParams.pageSize"
                  :pageIndex="child_pageParams.pageIndex"
                  :listTotal="child_listTotal"
                />
              </template>
            </el-table-column>
            <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100"></el-table-column>
            <el-table-column label="属性" prop="PropertyId" align="center" min-width="180">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.PropertyId" @change="changeProperty($event, row)" v-if="Status === 0 && row.UseProcess">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="ColorId" align="center" min-width="180">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="Status === 0 && colorList.length !== 0">
                  <el-option v-for="item in colorList" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单位" prop="BaseUnitName" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>{{ row.BaseUnitName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="Quantity" align="center" min-width="100">
              <template slot-scope="{ row, $index }">
                <el-input v-model="row.Quantity" @input="changeQuantity($event, row, $index)" placeholder="请输入数量" v-if="Status === 0" />
                <span v-else>{{ row.Quantity }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="WarehouseId" label="预出仓" min-width="120">
              <template slot-scope="{ row, $index }">
                <el-select v-model="row.WarehouseId" @change="changeOutWarehouse($event, row, $index)">
                  <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }}</el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column label="加工阶段" prop="ProcessStage" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>
                  {{
                    (() => {
                      if (row.ProcessStage === 4) {
                        return '组合'
                      } else if (row.ProcessStage === 3) {
                        return '装配'
                      } else if (row.ProcessStage === 1) {
                        return '注塑'
                      } else if (row.ProcessStage === 2) {
                        return '配件'
                      } else if (row.ProcessStage === 0) {
                        return '无'
                      }
                    })()
                  }}
                </span>
              </template>
            </el-table-column> -->
            <el-table-column label="存货类型" prop="ProduceTypeName" align="center" min-width="100"></el-table-column>
            <el-table-column label="损耗率" prop="Loss" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>{{ row.Loss }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click.stop="delTableList(row, $index)" v-if="Status === 0">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">工序</div>
          <el-table border key="table3" class="table_bottom table-line tb-c-head" :data="craftData" stripe style="margin-top: 18px" ref="table3">
            <el-table-column prop="ProgrammeName" label="工艺方案名称" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="changeProgramme(row)">{{ row.ProgrammeName ? row.ProgrammeName : '选择方案' }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="方案详情" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">模具对应胶件</div>
          <el-table border key="table3" class="table_bottom table-line tb-c-head" :data="Rubbers" stripe style="margin-top: 18px" ref="table3">
            <el-table-column label="胶件编码" prop="ProductNo" align="center" min-width="180"></el-table-column>
            <el-table-column label="胶件名称" prop="ProductName" align="center" min-width="180"></el-table-column>
            <el-table-column label="属性" prop="PropertyId" align="center" min-width="180">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.PropertyId" @change="changeProperty($event, row)" v-if="Status === 0 && row.UseProcess">
                  <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
                </el-select>
                <span v-else>{{ row.PropertyName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="颜色" prop="ColorId" align="center" min-width="180">
              <template slot-scope="{ row }">
                <el-select filterable clearable v-model="row.ColorId" @change="changeColor($event, row)" v-if="Status === 0 && colorList.length !== 0">
                  <el-option v-for="item in colorList" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName"></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="存货条码" prop="BarCode" align="center" min-width="100"> </el-table-column>
            <el-table-column label="数量(个)" prop="Quantity" align="center" min-width="180"></el-table-column>
            <el-table-column label="单重" prop="Weight" align="Weight" min-width="180"></el-table-column>
            <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <process-dialog ref="processDialog" @saved="detail_saved"></process-dialog>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
    <img-dialog ref="imgDialog" :imgs="imgs" />
  </div>
</template>
<script>
import accountSelect from '@/components/business/stock/select'
import imgDialog from '@/components/production/craftsmanship/bom/imgDialog'
import processDialog from '@/components/production/craftsmanship/combinationbom/processDialog'
import listDialog from '@/components/production/craftsmanship/solutions/mold/listDialog'
import { urlHttp } from '@/components/production/craftsmanship/bom/bomConfig'
import childSelect from '@/components/business/stock/childSelect'
export default {
  name: 'editcommodulbom',
  components: {
    accountSelect,
    imgDialog,
    listDialog,
    processDialog,
    childSelect
  },
  data() {
    return {
      Status: 0,
      viewType: 'create',
      colorApi: require('@/api/ba/color').default,
      propertyApi: require('@/api/ba/property').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/stock/stInDoc').default,
      save2Api: require('@/api/production/teMouldBom').default,
      childApi: require('@/api/ba/product').default,
      pdApi: require('@/api/ba/mould').default,
      apiChild: require('@/api/production/teProduct').default,
      teProgrammeApi: require('@/api/production/teProgramme').default,
      propertyList: [],
      colorList: [],
      tradeUnitList: [],
      isSave: true,
      initDAccount: [],
      MakeEmpName: '',
      ReviewEmpName: '',
      id: 0,
      Head: [
        { Value: 'MouldNo', Name: '模具编号', Width: '110' },
        { Value: 'MouldName', Name: '模具名称', Width: '110' },
        { Value: 'Weight', Name: '模具重量', Width: '110' },
        { Value: 'UnitName', Name: '重量单位', Width: '110' },
        { Value: 'ReplaceMouldName', Name: '替换模具', Width: '110' },
        { Value: 'Loss', Name: '损耗率(%)', Width: '110' },
        { Value: 'Price', Name: '加工单价', Width: '110' },
        { Value: 'WarehouseName', Name: '所在仓库', Width: '110' }
      ],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      child_arrList: [],
      child_initDAccount: [],
      child_initTotal: 0,
      deleteList: [],
      child_DAccount: [],
      child_listTotal: 0,
      imgs: [],
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      child_pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      Rubbers: [
        {
          T: 0,
          TemouldBomId: 0,
          PropertyId: 0,
          ColorId: 0,
          PropertyName: '',
          ColorName: '',
          BarCode: '',
          ColorNo: '',
          PropertyNo: ''
        }
      ],
      DetailDtos: [
        {
          T: 0,
          MouldId: 0,
          MouldNo: '',
          MouldName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          ImgUrl: '',
          ProcessStage: '',
          ProduceTypeName: '',
          child_arrList: [],
          ChildTeProductId: 0,
          ChildBomNo: '',
          Units: [],
          UseColor: true,
          ColorId: 0,
          ColorName: '',
          Colors: [],
          Loss: 0,
          BaseUnitName: '',
          BaseUnitId: '',
          WarehouseId: null
        }
      ],
      craftData: [
        {
          ProgrammeName: '',
          ProgrammeId: 0,
          Processes: []
        }
      ],
      deleteCraftData: [],
      warehouseList: [],
      tableData: [
        {
          MouldId: 0,
          MouldNo: '',
          MouldName: '',
          ProductSpec: '',
          Status: 0,
          UnitId: 0,
          UnitName: '',
          Quantity: 1,
          ImgUrl: '',
          ProcessStage: '',
          ProduceTypeName: '',
          TemouldBomId: 0,
          BomNo: '',
          Yieldrate: 100,
          ProductionType: 1,
          ProductionDpNo: '',
          ProductionDpId: 0,
          IsDefault: false,
          Units: [],
          UseColor: true,
          UseProccess: false
        }
      ]
    }
  },
  created() {
    this.init()
    if (this.$route.params.type == 'edit') {
      this.id = this.$route.params.data.TemouldBomId
      this.editOrder(this.$route.params.data.TemouldBomId)
    }
    if (this.$route.params.type == 'details') {
      this.editOrder(this.$route.params.data.TemouldBomId)
    }
    this.warehouseApi.list({ WarehouseType: 1 }).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })
  },
  computed: {
    ReviewName() {
      return this.Status == 2 ? '弃审' : '审核'
    }
  },
  methods: {
    changeOutWarehouse(val, row, index) {
      // console.log("val",val,"row",row)
      if (row.T !== 0) {
        row.T = 1
      }
      var obj = { ...row }
      this.DetailDtos.splice(index, 1, obj)
      //this.$forceUpdate()
    },
    editOrder(data) {
      this.isSave = false
      this.save2Api.info(data).then(res => {
        if (res.Code === 0) {
          this.Status = res.Data.Status
          this.MakeEmpName = res.Data.MakeEmpName
          this.ReviewEmpName = res.Data.ReviewEmpName
          this.tableData[0].TeProductId = res.Data.TeProductId
          this.tableData[0].TemouldBomId = res.Data.TemouldBomId
          this.id = res.Data.TemouldBomId
          this.tableData[0].BomNo = res.Data.Bomno
          this.tableData[0].MouldId = res.Data.MouldId
          this.tableData[0].MouldNo = res.Data.MouldNo
          this.tableData[0].ProductSpec = res.Data.ProductSpec
          this.tableData[0].UnitId = res.Data.UnitId != null ? res.Data.UnitId : 0
          this.tableData[0].UnitName = res.Data.UnitName
          this.tableData[0].ImgUrl = res.Data.ImgUrl
          this.tableData[0].Imgs = res.Data.Imgs
          this.tableData[0].Quantity = res.Data.Quantity
          this.tableData[0].ProcessStage = res.Data.ProcessStage
          this.tableData[0].MouldName = res.Data.MouldName
          this.tableData[0].Yieldrate = Number(res.Data.Yieldrate) / 0.01
          this.tableData[0].ProductionDpNo = res.Data.ProductionDpNo
          this.tableData[0].ProductionType = res.Data.ProductionType
          this.tableData[0].IsDefault = res.Data.IsDefault
          this.tableData[0].ProductionDpId = res.Data.ProductionDpId
          this.tableData[0].ProduceTypeName = res.Data.ProduceTypeName
          this.tableData[0].PerGrossWeight = res.Data.PerGrossWeight
          this.tableData[0].PerNetWeight = res.Data.PerNetWeight
          let arr = []
          res.Data.BomRubbers.forEach(item => {
            item.T = null
            item.Weight = item.Grammage
          })

          this.Rubbers = res.Data.BomRubbers
          if (this.Rubbers != []) {
            this.Rubbers.forEach(item => {
              item.R = null
            })
          }
          let ProcessModels = res.Data.ProcessModels

          if (ProcessModels != null && ProcessModels.length > 0) {
            let arr = []
            ProcessModels.forEach(item => {
              item.T = 1
            })
            let o = {
              ProgrammeName: ProcessModels[0].ProgrammeName,
              ProgrammeId: ProcessModels[0].ProgrammeId,
              Processes: ProcessModels
            }
            arr.push(o)
            this.craftData = arr //ProcessModel
          }
          res.Data.DetailDtos.forEach(item => {
            item.T = null
            let o = {
              ...item
            }
            arr.push(o)
          })
          this.DetailDtos = arr
          this.DetailDtos.forEach(item => {
            if (item.UnitId == null) item.UnitId = 0
            if (item.UnitId2 == null) item.UnitId2 = 0

            item.BaseUnitId = item.UnitId
            item.BaseUnitName = item.UnitName
          })
          console.log(this.DetailDtos, 'this.DetailDtos')
          if (this.DetailDtos.length === 0) {
            this.addList()
          }
        }
      })
    },
    changeProperty(val, row) {
      console.log(val, row, 'changeProperty')
      if (row.T !== 0) {
        row.T = 1
      }
      row.PropertyNo = ''
      if (val) {
        var property = this.propertyList.find(x => x.PropertyId == val)
        if (property) {
          row.PropertyNo = property.PropertyNo
        }
      }

      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || '0')
      }
    },
    changeColor(e, row) {
      // 模具对应胶件修改颜色
      if (row.T !== 0) {
        row.T = 1
      }
      row.ColorNo = ''
      if (e) {
        var color = this.colorList.find(x => x.ColorId == e)
        if (color) {
          row.ColorNo = color.ColorNo
        }
      }
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || '0')
      }
    },
    orderReview() {
      if (this.id == 0) {
        this.$message.warning('订单未保存')
        return
      }
      const message = this.Status == 2 ? '确认要弃审吗？ ' : '确认提交审核吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = this.Status == 2 ? 'back' : 'review'
          this.save2Api[data](this.id).then(res => {
            if (res.Code === 0 && data == 'review') {
              this.Status = 2
            }
            if (res.Code === 0 && data == 'back') this.Status = 0
            res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

            if (res.Code === 0) {
              this.editOrder(this.id)
            }
          })
        })
        .catch(() => {})
    },

    resetChildFun() {
      this.pageParams.pageIndex = 1

      this.child_DAccount = this.child_initDAccount
      this.child_listTotal = this.child_initTotal
    },
    currentChildPage({ val, text1 }, row) {
      var ProductName = row.ProductName
      this.pageParams.pageIndex = val
      this.childApi
        .list({
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ProcessStage: 0,
          ProductName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.child_DAccount = res.Data
            this.child_listTotal = res.Count
          }
        })
    },
    inputChildText(text, row) {
      if (text == row.ProductName) {
        //console.log("相同", text);
        return
      }
      this.childApi
        .list({
          Status: 1,
          pageIndex: 1,
          pageSize: 7,
          ProcessStage: 0,
          ProductName: text
        })
        .then(res => {
          if (res.Code == 0) {
            this.child_DAccount = res.Data
            this.child_listTotal = res.Count
          }
        })
    },
    changeQuantity(data, row, index) {
      if (row.T == null) row.T = 1
    },
    onSelectChild(e, row) {
      row.ChildTeProductId = e.TeProductId
      row.ChildBomNo = e.Bomno
      // console.log(row.BomNo,' row.BomNo')
    },
    changeProgramme() {
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row) {
      this.$refs.processDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    listDialogSelect(list) {
      let temps = JSON.parse(JSON.stringify(this.craftData))

      if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
        temps[0].Processes.forEach(item => {
          item.T = 2
        })

        this.deleteCraftData.push(...temps)
      }
      console.log('list 方案', list)
      this.craftData[0].ProgrammeId = list.ProgrammeId
      this.craftData[0].ProgrammeName = list.ProgrammeName
      this.craftData[0].Processes = list.Processes
    },
    detail_saved(list) {
      console.log('list', list)
      this.craftData[0].Processes = list
    },
    init() {
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })
      this.pdApi
        .MouldList({
          Statuses: [1, 2],
          pageIndex: 1,
          pageSize: 7
        })
        .then(res => {
          // let data = res.Data.filter(item => {
          //   return item.ProcessStage === 4
          // })
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count

          // let data1 = res.Data.filter(item => {
          //   return item.ProcessStage === 0 || item.ProcessStage === 3;
          // })
        })
      this.childApi
        .list({
          Status: 1,
          pageIndex: 1,
          pageSize: 7,
          ProcessStage: 0
        })
        .then(res => {
          this.child_DAccount = res.Data
          this.child_initDAccount = res.Data
          this.child_listTotal = res.Count
          this.child_initTotal = res.Count
        })
      //childApi
      this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.propertyList = res.Data
        }
      })
      this.colorApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.colorList = res.Data
        }
      })
    },
    delTableList(data, index) {
      if (data.T == null) data.T = 2
      if (data.T == 0) data.T = null
      this.deleteList.push(data)

      this.DetailDtos.splice(index, 1)
      if (this.DetailDtos.length === 0) this.addList()
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    addColumn(row, column) {
      if (this.Status == 2) return
      if (column.label === '操作') {
        return
      }
      if (row.index === this.DetailDtos.length - 1) {
        this.addList()
      }
    },
    addList() {
      this.DetailDtos.push({
        T: 0,
        MouldId: 0,
        MouldNo: '',
        MouldName: '',
        ProductSpec: '',
        UnitId: 0,
        UnitName: '',
        Quantity: 0,
        ImgUrl: '',
        ProcessStage: '',
        ProduceTypeName: '',
        child_arrList: [],
        ChildTeProductId: 0,
        ChildBomNo: '',
        Units: [],
        UseColor: true,
        ColorId: 0,
        ColorName: '',
        Colors: [],
        Loss: 0
      })
    },
    changeProductionDp(val, row) {
      let item = this.tradeUnitList.filter(v => {
        return v.TradeUnitId === val
      })[0]
      row.ProductionDpNo = item.TradeUnitNo
    },
    onSelect(e, row, type = 0) {
      if (type == 1) {
        //if(this.tableData[0].MouldId== e.MouldId)  return  this.$message.warning("请选择与存货不相同的子件存货");
        row.ProductName = e.ProductName
        row.ProductId = e.ProductId
        row.ProductNo = e.ProductNo
        row.ProductSpec = e.ProductSpec
        row.BaseUnitId = e.BaseUnitId
        row.BaseUnitName = e.BaseUnitName
        if (row.TeMouldBomDetailId > 0) {
          row.T = 1
        } else {
          row.T = 0
          row.Quantity = 1
        }
        row.ColorId = null
        row.ColorName = ''
        row.PropertyId = null
      } else {
        row.MouldName = e.MouldName
        row.TemouldBomId = 0
        ;(row.MouldId = e.MouldId), (row.MouldNo = e.MouldNo)
        row.ProductSpec = e.MachineType
        row.PerGrossWeight = e.PerGrossWeight
        row.PerNetWeight = e.PerNetWeight
        this.Rubbers = e.Rubbers
        row.BomNo = e.MouldName
        row.IsDefault = true

        this.Rubbers.forEach(item => {
          item.PropertyId = null
          item.BarCode = item.ProductNo + '*0*0*0'
          if (item.TrademarkNo) {
            item.BarCode = item.ProductNo + '*0*0*' + (item.TrademarkNo || 0)
          }
        })
      }
      row.UnitId = e.BaseUnitId
      row.UnitName = e.BaseUnitName
      row.Colors = e.Colors || []
      row.UseColor = e.UseColor
      row.UseProccess = e.UseProccess

      // if(e.Units.length === 0){
      //   row.UnitId = e.PdUnitId;
      //   row.UnitName = e.PdUnitName;
      // }else{
      //   row.Units = e.Units;
      // }
      row.Imgs = e.Imgs
      row.ProcessStage = e.ProcessStage
      row.ProduceTypeName = e.ProduceTypeName
      row.WarehouseId = e.DefaultWarehouse
      if (type === 0 && e.HasProgramme) {
        console.log('触发', e.HasProgramme)
        this.teProgrammeApi
          .list({
            ProgrammeType: 0,
            MouldNo: row.MouldNo,
            IsDefault: true
          })
          .then(res => {
            if (res.Code === 0) {
              if (this.viewType === 'create') {
                let { ProgrammeId, ProgrammeName, Processes } = res.Data[0]
                let o = {
                  ProgrammeName,
                  ProgrammeId,
                  Processes
                }

                let arr = []
                arr.push(o)
                let temps = JSON.parse(JSON.stringify(this.craftData))
                if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
                  temps[0].Processes.forEach(item => {
                    item.T = 2
                  })

                  this.deleteCraftData.push(...temps)
                }
                this.craftData = arr

                console.log('this.craftData', this.craftData)
              }
            }
          })
      }

      if (!e.HasProgramme && type === 0) {
        let temps = JSON.parse(JSON.stringify(this.craftData))
        if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
          temps[0].Processes.forEach(item => {
            item.T = 2
          })

          this.deleteCraftData.push(...temps)
        }
        this.craftData = [
          {
            ProgrammeName: '',
            ProgrammeId: 0,
            Processes: []
          }
        ]
      }
      //   if(type==1){
      // let data={
      //   pageIndex:1,
      //   pageSize:10,
      //   ProductId:row.MouldId
      // }
      // this.apiChild.list(data).then(res=>{
      // if(res.Code==0){
      //     row.child_arrList=res.Data
      // }
      // })
      // }
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.childApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      let MouldName = row.MouldName
      this.pageParams.pageIndex = val
      this.pdApi
        .MouldList({
          Statuses: [1, 2],
          pageIndex: val,
          pageSize: 7,
          MouldName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    inputText(text, row) {
      if (text == row.MouldName) {
        return
      }
      this.pdApi
        .MouldList({
          Statuses: [1, 2],
          pageIndex: 1,
          pageSize: 7,
          MouldName: text
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    newAdd() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$route.params.type = 'create'
      this.viewType = 'create'
      this.init()
    },
    save() {
      let data = this.tableData[0]
      // return this.$message.warning("数量不能为空并且不为0");
      if (data.BomNo == '') return this.$message.warning('bom版本号不能为空')
      if (data.MouldId == '') return this.$message.warning('请选择模具')
      if (data.PerNetWeight > data.PerGrossWeight) return this.$message.warning('净重>毛重，不允许保存')
      if (data.Quantity == 0) return this.$message.warning('需求数量请输入大于0')
      console.log('DetailDtos', this.DetailDtos)
      this.DetailDtos = this.DetailDtos.filter(item => item.ProductId > 0 && item.T !== null)
      this.Rubbers = this.Rubbers.filter(item => item.T !== null)
      // for (let i = 0; i < this.Rubbers.length; ++i) {
      //   if (this.Rubbers[i].Colors.length !== 0 && (this.Rubbers[i].ColorId === 0 || this.Rubbers[i].ColorId == null)) {
      //     return this.$message.warning('胶件请选择颜色')
      //   }
      // }
      for (let i = 0; i < this.DetailDtos.length; i++) {
        if (this.DetailDtos[i].Quantity == 0 || this.DetailDtos[i].Quantity == '') return this.$message.warning('子件的需求数量不能为0或为空')
      }
      data.Status = this.Status
      this.deleteList = this.deleteList.filter(item => item.T !== null)
      this.DetailDtos = this.DetailDtos.concat(this.deleteList)
      data.DetailDtos = this.DetailDtos
      data.BomRubbers = this.Rubbers
      let arr = []

      this.craftData[0]?.Processes?.forEach(item => {
        let o = {
          T: item.T ?? 0,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId,
          TeMouldBomProcessId: item.TeMouldBomProcessId ?? 0,
          TemouldBomId: item.TemouldBomId ?? 0,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      this.deleteCraftData[0]?.Processes?.forEach(item => {
        let o = {
          T: 2,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId ?? 0,
          TeMouldBomProcessId: item.TeMouldBomProcessId,
          TemouldBomId: item.TemouldBomId,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })
      data.ProcessModels = arr
      data.Yieldrate = Number(data.Yieldrate) * 0.01

      this.save2Api
        .save(data)
        .then(res => {
          if (res.Code == 0) {
            if (res.Data > 0) data.TemouldBomId = res.Data
            this.id = res.Data
            this.$message({ type: 'success', message: res.Msg })
            this.editOrder(data.TemouldBomId)
            this.close()
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    reView() {},
    tabClick() {}
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 18px;
}
.text-box {
  display: inline-block;
  margin-left: 18px;
  width: 180px;
}
</style>


